/**
 * CMCD request mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_REQUEST_MODE = 'request';
//# sourceMappingURL=CMCD_REQUEST_MODE.js.map